<button
  pButton
  [label]="label | translate"
  [loading]="loading"
  (click)="onClear()"
  class="p-button-secondary clear-btn"
  [ngClass]="styleClass"
  type="button"
>
</button>
